import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

const ModalCandidato = ({ currentCandidato, setShowModal, fullPage }) => {
  return (
    <div
      className={
        fullPage ? "modal-container-bg modal-full" : "modal-container-bg"
      }
    >
      <div className="modal-card rounded bg-light">
        <div className="bg-white p-4">
          <div className="d-flex justify-content-end">
            <FontAwesomeIcon
              icon={faTimes}
              className="purple close-icon"
              onClick={() => setShowModal(false)}
            />
          </div>
          <div className="row align-items-stretch ">
           
            <div className="col-12">
              <div className=" p-4 h-100 rounded position-relative d-flex flex-column justify-content-between">
                <div>
                  <h2 className="purple">
                    <strong>{currentCandidato.candidato}</strong>
                  </h2>
                  <p className="purple">
                    {currentCandidato.region}
                  
                  </p>
                  <p className="mb-0">
                    <small>
                      Año: <strong>{currentCandidato.year}</strong>
                    </small>
                  </p>
                  <p className="mb-0">
                    <small>
                      Eje: <strong>{currentCandidato.delito}</strong>
                    </small>
                  </p>
                  <p className="mb-0">
                    <small>
                      Nro procedimiento: <strong>{currentCandidato.dni}</strong>
                    </small>
                  </p>
                  <p className="mb-0">
                    <small>
                     cargo funcional: <strong>{currentCandidato.cargo}</strong>
                    </small>
                  </p>
                  <p className="mb-0">
                    <small>
                      Decisión final: <strong>{currentCandidato.decision}</strong>
                    </small>
                  </p>
                  <p className="mb-0">
                    <small>
                      Estado: <strong>{currentCandidato.estado}</strong>
                    </small>
                  </p>
                  <p className="mb-0">
                    <small>
                      Fecha: <strong>{currentCandidato.fecha}</strong>
                    </small>
                  </p>
                  <p className="">
                    <small>
                      Resolución: <strong>{currentCandidato.link ? <a href={currentCandidato.link}  target="_blank" rel="noreferrer" >{currentCandidato.resolucion}</a> : currentCandidato.resolucion }</strong>
                    </small>
                  </p>
                
                </div>
                <div className="row">
                  <div className="col-12">
                    <p className="text-muted source">
                      <small>
                      Esta herramienta de periodismo de datos fue elaborada en el marco del Curso de Actualización en Periodismo y Política - Edición 2023, de la PUCP, IDEA Internacional y la Fundación Gustavo Mohme Llona. 
                      </small>
                    </p>
                  </div>
                </div>
             
              </div>
            </div>
          </div>
        
        </div>
      </div>
    </div>
  );
};

export default ModalCandidato;
